
<div class="w-full">
    <div class="bg-card shadow rounded-2xl p-5 m-4">
        <div class="text-2xl  text-center font-medium tracking-tight leading-6 mb-6 truncate">
            Option Type
        </div>

        <div class="flex justify-end">
            <button class="btn btn-outline" (click)="addOptions()">Add New</button>

           

            <div class="w-18 mx-4">
                <mat-form-field class="w-full">
                    <mat-select [(ngModel)]="filterData.pageSize" (selectionChange)="getOptions()">
                        <mat-option [value]="10"> 10 </mat-option>
                        <mat-option [value]="20"> 20 </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <mat-form-field class="w-48">
                <input matInput placeholder="Search Category">
                <mat-icon [svgIcon]="'heroicons_solid:magnifying-glass'"></mat-icon>
            </mat-form-field>

            <button class="btn btn-outline ml-4" (click)="exportToExcel()">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
                </svg>
            </button>
        </div>

        <div class="overflow-x-auto">
            <table class="table table-zebra text-center">
                <thead class="header">
                    <tr class="tableHeader-bg-color">
                        <td class="w-12"> No </td>
                        <td> Category Name </td>
                        <td> ID </td>
                        <td class="w-16"> </td>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngIf="(options$ | async) as options; else noData">
                        <ng-container *ngFor="let optionCategory of options.data.data, let i = index">
                            <tr>
                                <td>{{ i + 1 }}</td>
                                <td>{{ optionCategory.name }}</td>
                                <td>{{ optionCategory.id }}</td>
                                <td class="flex">
                                    <button class="btn btn-remove-bg" (click)="editOptionType(optionCategory)">
                                        <mat-icon style="color:#FFC300"
                                            [svgIcon]="'heroicons_solid:pencil-square'"></mat-icon>
                                    </button>
                                    <button class="btn btn-remove-bg mx-2"
                                        (click)="navigateToDetailsPage(optionCategory.id, optionCategory.name,optionCategory.optionItem)">
                                        <mat-icon class="icon-custom" [svgIcon]="'heroicons_solid:eye'"></mat-icon>
                                    </button>
                                    <button class="btn btn-remove-bg" (click)="deleteOptionType(optionCategory.id)">
                                        <mat-icon style="color:rgb(232, 88, 88)"
                                            [svgIcon]="'heroicons_solid:trash'"></mat-icon>
                                    </button>
                                </td>
                            </tr>
                        </ng-container>
                    </ng-container>
                </tbody>

                <ng-template #noData>
                    <tr>
                        <td style="background-color: #f5f5f5;" colspan="10">No data available</td>
                    </tr>
                </ng-template>
            </table>
        </div>

        <!-- pagination -->
        <div class="divider mt-2"></div>
        <div class="join flex justify-between w-full">
            <button class="join-item btn btn-remove-bg" [disabled]="filterData.pageNumber <= 1"
                (click)="previousPage()">
                <mat-icon [svgIcon]="'heroicons_outline:arrow-long-left'"></mat-icon>
                Previous</button>
            <button class="join-item">Page {{ filterData.pageNumber }}</button>
            <button class="join-item btn btn-remove-bg"
                [disabled]="(options$ | async)?.data.totalPages <= filterData.pageNumber" (click)="nextPage()">
                Next
                <mat-icon [svgIcon]="'heroicons_outline:arrow-long-right'"></mat-icon>
            </button>
        </div>
    </div>
</div>
